import { useEffect, useRef } from 'react';

import { SubmitInterceptor, useFormContext } from './FormContext';

type Props = {
  onIntercept: SubmitInterceptor;
};

/**
 * Allows performing actions such as updating a value before submitting the form.
 */
export function useFormSubmitInterceptor({ onIntercept }: Props) {
  const { addSubmitInterceptor } = useFormContext();

  const onInterceptRef = useRef(onIntercept);
  onInterceptRef.current = onIntercept;

  useEffect(
    // Remove when unmounted
    () => addSubmitInterceptor(() => onInterceptRef.current()),
    [addSubmitInterceptor, onInterceptRef]
  );
}

export function FormSubmitInterceptor({ onIntercept }: Props) {
  useFormSubmitInterceptor({ onIntercept });

  return null;
}
